export const ROUTES = {
  home: '/',
  topCasinos: '/top-casinos',
  bestAusCasinos: '/best-aus-casinos',
  myTopPicks: '/my-top-picks',
  bestForGames: '/best-for-games',
  freeGames: '/free-games',
  reviews: '/reviews',
  newsGuides: '/new-guides',
  methodology: '/methodology',
  bonuses: '/bonuses',
} as const;

export type NavItem = {
  label: string;
  to: string;
  icon?: string;
  badge?: string;
  openRandomPartner?: boolean;
};

export const PRIMARY_NAV_ITEMS: NavItem[] = [
  { label: 'Best AUS Casinos', to: ROUTES.bestAusCasinos, icon: 'ri-vip-crown-2-line' },
  { label: 'My Top Picks', to: ROUTES.myTopPicks, icon: 'ri-thumb-up-line' },
  { label: 'Best for Games', to: ROUTES.bestForGames, icon: 'ri-gamepad-line' },
  { label: 'Free Games', to: ROUTES.freeGames, icon: 'ri-copper-diamond-line', badge: 'New' },
  { label: 'Bonuses', to: ROUTES.bonuses, icon: 'ri-gift-2-line', openRandomPartner: true },
  { label: 'Player Reviews', to: ROUTES.reviews, icon: 'ri-star-line' },
  { label: 'News & Guides', to: ROUTES.newsGuides, icon: 'ri-newspaper-line' },
];
